import React from 'react'

// components
import { OauthRequestSocialType } from 'containers/oAuth/types/oAuth'
import { ButtonConnection } from './ButtonConnection'

interface ConnectionsButtonsContainerProps {
  allowDisconnect?: boolean
}

export const ConnectionButtonsContainer: React.FC<
  ConnectionsButtonsContainerProps
> = ({ allowDisconnect }) => {
  const buttons: OauthRequestSocialType[] = [
    OauthRequestSocialType.YOUTUBE,
    OauthRequestSocialType.INSTAGRAM,
    OauthRequestSocialType.TIKTOK,
  ]

  return (
    <div className="flex gap-12 flex-column full-w">
      {buttons.map((button) => (
        <ButtonConnection
          key={button}
          social={button}
          allowDisconnect={allowDisconnect}
        />
      ))}
    </div>
  )
}
